(function() {
  window.__central_management_global_vars__ = {
    baseResourceUrl: "/EM/",
    baseDataUrl: "CSHRIS-CSHRIS/EnterpriseManagerWS",
    baseTokenUrl: "CSHRIS-CSHRIS/AuthenticationServer"
  };
})();
